export default __webpack_public_path__ + "static/media/automotusLogoWhite.c143a996.svg";